import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, OnDestroy, Inject, ChangeDetectorRef} from '@angular/core';
import { MatTableDataSource} from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {AfterViewInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { AuditTrailSearchService } from '../audit-trail-search/audit-trail-search.service';
import { MatSort, Sort} from '@angular/material/sort';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import {LiveAnnouncer} from '@angular/cdk/a11y';

@Component({
  selector: 'dl-notification-audit-trail',
  templateUrl: './notification-audit-trail.component.html',
  styleUrls: ['./notification-audit-trail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationAuditTrailComponent implements OnInit, AfterViewInit {

  private _liveAnnouncer;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public initPageLoad = true;
  public displayedColumns = ['timestamp','modifiedBy','role','propertyName','oldValue','newValue'];
  public dataSource;
  public flag:boolean=false;
  
  public constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public auditTrailSearchService: AuditTrailSearchService, 
    public changeDetectorRef: ChangeDetectorRef,
    public appUtils: AppUtils,
    public dialogRef: MatDialogRef<any>,
    _liveAnnouncer:LiveAnnouncer
  ) {
    this.dataSource=new MatTableDataSource<any>(data.tableData);
  }

  public closeClicked(){
    this.dialogRef.close();
  }

  

  ngOnInit(): void {
    this.auditTrailSearchService.searchData$.subscribe(searchValue => 
      {
        this.dataSource.filter = searchValue;
        this.dataSource.filterPredicate = (data: any, filter: string) => 
          {
            return this.appUtils.getLowerCase(data.timestamp).includes(filter.toLowerCase()) 
            || this.appUtils.getLowerCase(data.modifiedBy).includes(filter.toLowerCase()) 
            || this.appUtils.getLowerCase(data.role).includes(filter.toLowerCase()) 
            || this.appUtils.getLowerCase(data.propertyName).includes(filter.toLowerCase()) 
            || this.appUtils.getLowerCase(data.oldValue).includes(filter.toLowerCase()) 
            || this.appUtils.getLowerCase(data.newValue).includes(filter.toLowerCase()) ;
          };
        this.changeDetectorRef.detectChanges();
      });
  }
  
  isString(input){
    if(typeof input==='string' || typeof input==='boolean' || input===''){
      return true;
    }
    return false;
  }

  toJSON(input){
    return JSON.stringify(input,null,4)
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
}
